module.exports = __webpack_public_path__ + "img/sample3-voronoi-inverse.74ad2652.png";